/** @format */
export enum AttributeType {
	BLOCKS = 'Blocks',
	SWATCH = 'Swatch'
}
